//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button.vue'
import ModalWithTitleBar from '@/components/Shared/ModalWithTitleBar'

export default {
  components: {
    Button,
    ModalWithTitleBar,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    supervisorData: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onClose() {
      this.$emit('close', true)
    },
    onConfirm() {
      this.$emit('confirm', this.supervisorData.id)
    },
  },
}
